import { useQuery } from "@tanstack/react-query";

/**
 *
 * @param {Array} queryKey
 * @param {Function} queryFn
 * @param {Object} options
 * @returns {Object} 
 */
const useReactQueryCustomHook = (queryKey, queryFn, options = {}) => {
  const hasValidKey = queryKey && queryKey.length > 0;
  return useQuery(
    hasValidKey ? queryKey : ['__disabled__'],
    hasValidKey ? queryFn : () => Promise.resolve(null),
    {
      ...options,
      enabled: hasValidKey && options.enabled !== false,
      staleTime: 1000 * 60 * 60 * 6, // after 6 hours react query will fetch API.
      initialDataUpdatedAt: Date.now(), // this has timestamp of last updated.
      refetchOnWindowFocus: false, // this tell react query do not fetch when focus on window.
    }
  );
};

export default useReactQueryCustomHook;
